module.exports = __webpack_public_path__ + "static/img/Training.e5052cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Training.png
// module id = zlPG
// module chunks = 0